export function progress_indeterminate(state = true, action) {
  if (action.type === 'SHOW_PROGRESS_INDETERMINATE') {
    return true;
  }
  if (action.type === 'HIDE_PROGRESS_INDETERMINATE') {
    return false;
  }

  return state;
}
